import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, Output, EventEmitter, } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';

@Component({
  selector: 'app-unlayer',
  templateUrl: './unlayer.component.html',
  styleUrls: ['./unlayer.component.css']
})

export class UnlayerComponent {

  @Output() public editorscript: EventEmitter<any> = new EventEmitter<any>();
  @Input() public editscripteditor: any;
  @Input() public custVar: any;
  @Input() public agent: any;
  @Input() public appointment: any;
  title = 'angular-email-editor';

  @ViewChild(EmailEditorComponent)
  private emailEditor: EmailEditorComponent;

  @Output() public editorEvent: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    console.log("this.editscripteditor::", this.editscripteditor);
    // @loading emailEditor component
    this.editorEvent.emit(this.emailEditor)
  }

  options = {
    tools: {
      text: {
        properties: {
          text: {
            value: '<span style="font-size: 14px; line-height: 19.6px;">This is a new Text block. Change the text.</span>'
          },
          color: {
            value: '#D81B1B'
          }
        }
      },
      image: {
        properties: {
          src: {
            value: {
              url: 'https://via.placeholder.com/500x100?text=IMAGE',
              width: 500,
              height: 100
            }
          }
        }
      },
      html: {
        properties: {
          containerPadding: {
            value: "10px"
          }
        }
      },
    },

    // mergeTags: {
    //   first_name: {
    //     name: "First Name",
    //     value: "{{first_name}}",
    //     sample: "John"
    //   },
    //   last_name: {
    //     name: "Last Name",
    //     value: "{{last_name}}",
    //     sample: "Doe"
    //   }
    // },

    dat: {
      products: [{
        name: "Product 1",
        price: "$7.99"
      },
      {
        name: "Product 2",
        price: "$7.99"
      },
      {
        name: "Product 3",
        price: "$7.99"
      }
      ]
    },
    mergeTags: {
      first_name: {
        name: "Product Name",
        value: "{{name}}",
      },
      price: {
        name: "Price",
        value: "{{price}}",
      },
      products: {
        name: "Products",
        rules: {
          repeat: {
            name: "Repeat for Each Product",
            before: "{{#products}}",
            after: "{{/products}}",

          },
        },
      }
    },
    designTags: {
      business_name: "Tesla Inc",
      current_user_name: "Elon Musk"
    },
    features: {
      textEditor: {
        spellChecker: true
      },
    }
  };

  editorLoaded(event: any) {
    // load the design json here
    if (this.editscripteditor != "") {
      console.log("this.editscripteditor2::", this.editscripteditor)
      // this.editscripteditor = JSON.parse(this.editscripteditor)
      if (Object.keys(this.editscripteditor).length > 0) {
        this.emailEditor.editor.loadDesign(this.editscripteditor)
      }
    }

    this.SetCustVar()
  }

  // exportHtmls() {
  //   this.emailEditor.editor.exportHtml(res => {
  //     this.editorscript.emit(res);
  //   });
  // }

  SetCustVar() {
    this.emailEditor.editor.setMergeTags({
      dialer: {
        name: "Dialer's Fields",
        mergeTags: this.custVar
      },
      agent: {
        name: "Agent's Fields",
        mergeTags: this.agent
      },
      appointment: {
        name: "Appointment's Fields",
        mergeTags: this.appointment
      }
    }

    );
  }

  // saveDesign() {
  //   this.emailEditor.editor.saveDesign(
  //     (data: any) => console.log('saveDesign', data)
  //   );
  // }

  // validateChange(event: any) {
  //   if (event !== null && event !== undefined) {
  //     console.log(event.html);
  //     this.editorscript.emit(event);
  //   }
  // }

}